import { ApiCancellationReason, ApiOrderCancellationActor, type OrderCancellationAnalyticsApiGetCancelledOrdersRequest } from '@/core/generated/api';
import { asGuardedFilterArray, asNonEmptyFilterString, getDataTableFilterValue } from '@/shared/lib/dataTableFilters';
import { dateTimeFilterToBounds } from '@/shared/lib/dateTimeFilter';
import type { CancellationListParams } from './model/types';

/** Преобразует условия таблицы в серверный запрос аналитики */
export const cancellationFiltersToRequest = (
    params: CancellationListParams
): OrderCancellationAnalyticsApiGetCancelledOrdersRequest => {
    const { filters } = params;
    const period = dateTimeFilterToBounds(getDataTableFilterValue(filters, 'cancelledAt'));

    return {
        takeCount: params.take,
        skipCount: params.skip,
        ordering: params.sortField,
        ascending: params.sortOrder === 1,
        orderNumberSearch: asNonEmptyFilterString(getDataTableFilterValue(filters, 'orderNumber')),
        descriptionSearch: asNonEmptyFilterString(getDataTableFilterValue(filters, 'description')),
        reasons: asGuardedFilterArray(getDataTableFilterValue(filters, 'reason'), isReason),
        initiators: asGuardedFilterArray(getDataTableFilterValue(filters, 'initiator'), isInitiator),
        cancelledAtFrom: period?.from,
        cancelledAtTo: period?.to,
    };
};

/** Проверяет известную причину отмены из сохранённого фильтра */
const isReason = (value: unknown): value is ApiCancellationReason => Object.values(ApiCancellationReason)
    .some(reason => reason === value);

/** Проверяет известного инициатора из сохранённого фильтра */
const isInitiator = (value: unknown): value is ApiOrderCancellationActor => Object.values(ApiOrderCancellationActor)
    .some(initiator => initiator === value);
